import wrong0 from "../images/0.jpg";
import wrong1 from "../images/1.jpg";
import wrong2 from "../images/2.jpg";
import wrong3 from "../images/3.jpg";
import wrong4 from "../images/4.jpg";
import wrong5 from "../images/5.jpg";
import wrong6 from "../images/6.jpg";

export const pictureArray = [wrong0, wrong1, wrong2, wrong3, wrong4, wrong5, wrong6]